import { Component } from "react";
import { connect } from "react-redux";
import { change } from "redux-form";
import actionCreators from "../../../../store/PersistentEvents/actionCreators";
import mainMenuActionCreators from "../../../../store/MainMenu/actionCreators";
import { default as AutoCompleteActionCreators } from "../../../../store/AutoComplete/actionCreators";
import { MainTitle } from "../../../../common/components/MainTitle";
import formsCss from "../../../../common/styles/forms.css";
import PersistentEventsForm from "../components/PersistentEventsForm";
import { GetFormattedDate } from "../../../../common/components/Time";
/** @jsx jsx */
import { jsx } from "@emotion/react";

class PersistentEventsEditContainer extends Component {
    componentDidMount() {
        const {
            getPersistentEvent,
            setTitle,
            match: {
                params: { id },
            },
        } = this.props;
        setTitle("LSE Calendar Events");
        getPersistentEvent(id);
    }

    componentWillUnmount() {
        this.props.clearTitle();
    }

    formSubmitHandler = values => {
        this.props.putPersistentEvents({
            ...values,
            startAt: values.isAllDay
                ? GetFormattedDate(values.startAt, "YYYY-MM-DD")
                : values.startAt,
            endAt: values.isAllDay ? GetFormattedDate(values.endAt, "YYYY-MM-DD") : values.endAt,
        });
    };

    render() {
        const {
            event,
            errorRes: { error, errors },
            changeEndAt,
            changeStartAt,
            getPages,
            getAudiences,
            updateAudience,
            formState,
            audiences,
            pages,
            getOwners,
            owners,
        } = this.props;

        return (
            <div>
                <MainTitle title="Edit LSE Calendar Event" />
                <div css={formsCss.genericError}>{error}</div>
                <PersistentEventsForm
                    submitText="Save Event"
                    subtitle="Edit Calendar Event"
                    initialValues={{
                        ...event,
                    }}
                    onSubmit={this.formSubmitHandler}
                    {...{
                        changeEndAt,
                        changeStartAt,
                        getPages,
                        getAudiences,
                        updateAudience,
                        formState,
                        audiences,
                        pages,
                        errors,
                        getOwners,
                        owners,
                    }}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ AutoComplete, PersistentEvents: { errorRes, event }, form }) => ({
    errorRes,
    event,
    formState: form.NewLseCalendarEvent,
    pages: AutoComplete.pages,
    audiences: AutoComplete.audiences,
    owners: AutoComplete.staff.map(owner =>
        Object.assign({ fullName: `${owner.firstName} ${owner.lastName}` }, owner)
    ),
});

const dispatchToProps = {
    getPersistentEvent: actionCreators.getPersistentEvent.create,
    putPersistentEvents: actionCreators.putPersistentEvents.create,
    clearTitle: mainMenuActionCreators.clearTitle.create,
    setTitle: mainMenuActionCreators.setTitle.create,
    getPages: AutoCompleteActionCreators.getPages.create,
    clearPages: AutoCompleteActionCreators.clearPages.create,
    getAudiences: AutoCompleteActionCreators.getAudiences.create,
    clearAudiences: AutoCompleteActionCreators.clearAudiences.create,
    changeEndAt: newValue => change("NewLseCalendarEvent", "endAt", newValue), // reset endAt value
    changeStartAt: newValue => change("NewLseCalendarEvent", "startAt", newValue), // reset startAt value
    updateAudience: (key, audience) => change("NewLseCalendarEvent", "audience." + key, audience),
    getOwners: AutoCompleteActionCreators.getStaffUsers.create,
};

export default connect(mapStateToProps, dispatchToProps)(PersistentEventsEditContainer);
